module.exports = __webpack_public_path__ + "img/A-active.e80659fb.png";